import { getAllTeams, ITeam } from 'wisestep-api';

const getTeamSettingsObject = [
  {
    key: 'jobShareNotificationTo',
    optOutKey: 'disableJobShareNotificationTo',
    text: 'When a Job is Shared',
    custom: 'customJobShareNotificationTo',
    model: 'jobShareNotificationToModel',
    justForProvider: true,
  },
  {
    key: 'jobClosedNotificationTo',
    optOutKey: 'disableJobClosedNotificationTo',
    text: 'When a Job is Closed',
    custom: 'customJobClosedNotificationTo',
    model: 'jobClosedNotificationToModel',
    justForProvider: false,
  },
  {
    key: 'jobInsightUpdateNotificationTo',
    optOutKey: 'disableJobInsightUpdateNotificationTo',
    text: 'Job insights update',
    custom: 'customJobInsightUpdateNotificationTo',
    model: 'jobInsightUpdateNotificationToModel',
    justForProvider: false,
  },
  {
    key: 'candidateSubmissionNotificationTo',
    optOutKey: 'disableCandidateSubmissionNotificationTo',
    text: 'When a Candidate is Submitted',
    custom: 'customCandidateSubmissionNotificationTo',
    model: 'candidateSubmissionNotificationToModel',
    justForProvider: false,
  },
  {
    key: 'candidateStatusUpdateNotificationTo',
    optOutKey: 'disableCandidateStatusUpdateNotificationTo',
    text: 'When a Candidate Status is Update',
    custom: 'customCandidateStatusUpdateNotificationTo',
    model: 'candidateStatusUpdateNotificationToModel',
    justForProvider: false,
  },
];
export const initializeTeamSettings = async () => {
  try {
    const getAllTeamsReq = await getAllTeams();

    const getAllTeamsRes: ITeam[] = getAllTeamsReq.data;
    getAllTeamsRes.forEach((team) => {
      getTeamSettingsObject.forEach((setting) => {
        team[setting.key] = team[setting.key] ? team[setting.key] : '';
        team[setting.model] = team[setting.key] ? team[setting.key].split(',') : '';
        team[setting.custom] = team[setting.key] ? true : false;
      });
    });
    return getAllTeamsRes;
  } catch {
    console.log('error');
  }
};
